import { useCallback } from "react";
import {
    clearResetPasswordFlow,
    getResetPasswordFlow,
    saveResetPasswordOtp,
    saveResetPasswordToken,
} from "@/shared/lib/token";

export function useResetPasswordFlow() {
    const startResetPasswordFlow = useCallback((resetToken: string) => {
        saveResetPasswordToken(resetToken);
    }, []);

    const setResetPasswordOtp = useCallback((otp: string) => {
        saveResetPasswordOtp(otp);
    }, []);

    const getResetFlow = useCallback(() => {
        return getResetPasswordFlow();
    }, []);

    const clearResetFlow = useCallback(() => {
        clearResetPasswordFlow();
    }, []);

    return {
        startResetPasswordFlow,
        setResetPasswordOtp,
        getResetFlow,
        clearResetFlow,
    };
}
